// RAWeb / WCAG 4.1.2 — Nom accessible des <iframe>.
//
// Passe runtime globale : toute <iframe> qui n'a PAS de nom accessible (ni title,
// ni aria-label, ni aria-labelledby) reçoit un title pertinent, dérivé de son src
// (fournisseur connu) avec un repli générique valide. On ne touche jamais une
// iframe déjà nommée (un title saisi en CMS est donc respecté).
//
// On n'écrit qu'un attribut invisible : aucun impact visuel ni SEO (le title
// d'iframe n'est pas un signal Google).
//
// Ré-exécution via MutationObserver pour les iframes injectées après le chargement
// (360 chargée au clic, lazy-embeds, embeds sociaux, contenu CMS asynchrone).

(function () {
  var LANGS = {
    fr: { video: "Vidéo", map: "Carte", gmaps: "Carte Google Maps", post: "Publication", v360: "Vue à 360°", player: "Lecteur", booking: "Réservation en ligne", embed: "Contenu intégré", embedFrom: "Contenu intégré : " },
    en: { video: "Video", map: "Map", gmaps: "Google Maps map", post: "Post", v360: "360° view", player: "Player", booking: "Online booking", embed: "Embedded content", embedFrom: "Embedded content: " },
    de: { video: "Video", map: "Karte", gmaps: "Google-Maps-Karte", post: "Beitrag", v360: "360°-Ansicht", player: "Player", booking: "Online-Reservierung", embed: "Eingebetteter Inhalt", embedFrom: "Eingebetteter Inhalt: " },
  };

  function strings() {
    var lang = (document.documentElement.getAttribute("lang") || "fr").slice(0, 2).toLowerCase();
    return LANGS[lang] || LANGS.fr;
  }

  function hasAccessibleName(f) {
    var t = f.getAttribute("title");
    if (t && t.trim()) return true;
    var al = f.getAttribute("aria-label");
    if (al && al.trim()) return true;
    if (f.getAttribute("aria-labelledby")) return true;
    return false;
  }

  function titleFor(f, t) {
    var src = (f.getAttribute("src") || f.getAttribute("data-src") || "").toLowerCase();
    var cls = (typeof f.className === "string" ? f.className : "").toLowerCase();
    var has = function (s) { return src.indexOf(s) !== -1; };

    if (cls.indexOf("view360") !== -1 || has("360view") || has("/360/") || has("poi=")) return t.v360;
    if (has("youtube") || has("youtu.be")) return t.video + " YouTube";
    if (has("vimeo.com")) return t.video + " Vimeo";
    if (has("dailymotion")) return t.video + " Dailymotion";
    if (has("google.") && has("map")) return t.gmaps;
    if (has("openstreetmap")) return t.map;
    if (has("tiktok.com")) return t.post + " TikTok";
    if (has("instagram.com")) return t.post + " Instagram";
    if (has("facebook.com")) return t.post + " Facebook";
    if (has("spotify.com")) return t.player + " Spotify";
    if (has("soundcloud.com")) return t.player + " SoundCloud";
    if (has("ingenie") || has("reservation") || has("booking") || has("buchung")) return t.booking;
    try {
      if (src) {
        var u = new URL(src, location.href);
        if (u.hostname && u.hostname !== location.hostname.toLowerCase()) return t.embedFrom + u.hostname.replace(/^www\./, "");
      }
    } catch (e) {}
    return t.embed;
  }

  function run() {
    try {
      var t = strings();
      var frames = document.querySelectorAll("iframe");
      for (var i = 0; i < frames.length; i++) {
        var f = frames[i];
        if (hasAccessibleName(f)) continue;
        f.setAttribute("title", titleFor(f, t));
      }
    } catch (e) {
      /* ne jamais casser la page */
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  // Contenu injecté après coup. On n'écrit que des attributs (title), donc
  // l'observer childList ne se re-déclenche pas lui-même : pas de boucle.
  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; run(); });
  });
  function startObserving() {
    try { observer.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startObserving);
  } else {
    startObserving();
  }
})();
